import * as R from 'ramda';
import { httpGet, httpPost } from 'apiModule/rest';
import adapter from 'dataModule/adapter';
import { getQueriesString } from 'utilsModule';

const retrievePatients = async ({ params: { queries = [] } = {} } = {}) =>
  R.pipe(
    getQueriesString,
    (queriesString) => httpGet(`monit/patients${queriesString}`),
    (response) => response.then(adapter.monit.retrievePatients.be2fe),
  )(queries);

const retrieveStatus = async ({ params: { queries = [] } = {} } = {}) =>
  R.pipe(
    getQueriesString,
    (queriesString) => httpGet(`monit/status${queriesString}`),
    (response) => response.then(adapter.monit.retrieveStatus.be2fe),
  )(queries);

const closeAlert = async ({ content: { data } }) =>
  R.pipe(adapter.monit.closeAlert.fe2be, httpPost('alerts/close'), (response) =>
    response.then(adapter.monit.closeAlert.be2fe),
  )(data);

const createNote = async ({ content: { data } }) =>
  R.pipe(adapter.monit.createNote.fe2be, httpPost('note/create'), (response) =>
    response.then(adapter.monit.createNote.be2fe),
  )(data);

const DM = {
  retrievePatients,
  retrieveStatus,
  closeAlert,
  createNote,
};

const ajax = async ({ method, input }) => ({
  [method]: await DM[method](input),
});

export default { ...DM, ajax };
